import { doCheck, doCheckS3 } from "../../api/attendance";

// Prefer the S3 direct-upload path (scales for the morning rush); fall back to
// posting frames inline when direct upload is not available on this deployment.
export const submitCheck = async ({ body, frames, uploadFrames }) => {
  try {
    const frame_keys = await uploadFrames(frames);
    return await doCheckS3({ ...body, frame_keys });
  } catch (error) {
    const status = error?.response?.status;
    if (status && status !== 503) throw error;
    return doCheck({ ...body, frames });
  }
};
